import { readable } from 'svelte/store';
export const isDragging = readable(false, function start(set) {
    function dragstart() {
        console.log('dragstart');
        set(true);
    }
    function dragend() {
        console.log('dragend');
        set(false);
    }
    function drop() {
        console.log('drop');
        set(false);
    }
    window.addEventListener('dragstart', dragstart);
    window.addEventListener('dragend', dragend);
    window.addEventListener('drop', drop);
    return function stop() {
        window.removeEventListener('dragstart', dragstart);
        window.removeEventListener('dragend', dragend);
        window.removeEventListener('drop', drop);
    };
});
